import Glide from '@glidejs/glide';
import baguetteBox from 'baguettebox.js';

document.addEventListener('DOMContentLoaded', () => {
  const homepageCarousel = document.getElementsByClassName('homepage-carousel');

  if (homepageCarousel.length > 0) {
    // Init glide
    const glide = new Glide('.homepage-carousel', {
      type: 'carousel',
      gap: 0,
      autoplay: false, // 5000,
    })

    glide.on('run.start', () => {
      if (window.blazy && typeof window.blazy.revalidate === 'function') {
        window.blazy.revalidate();
      }
    });

    glide.mount();

    baguetteBox.run('.homepage-carousel', {
      async: true,
      animation: 'fadeIn',
      captions: false,
      buttons: false,
      noScrollbars: true,
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/homepage-carousel.js